import styles from "./SlidePageIndicatorControl.module.css";

function SlidePageIndicatorControl({
    currentSlide,
    setCurrentSlide,
    totalSlides,
    className,
}) {
    function handleButtonClick(index) {
        setCurrentSlide(index);
    }

    return (
        <div id={styles.control_container} className={className}>
            {Array(totalSlides)
                .fill(0)
                .map((_, index) => (
                    <button
                        key={index}
                        className={styles.button_container}
                        onClick={() => handleButtonClick(index)}
                    >
                        <div
                            className={[
                                styles.button,
                                index === currentSlide
                                    ? styles.current_slide
                                    : "",
                            ].join(" ")}
                        ></div>
                    </button>
                ))}
        </div>
    );
}

export default SlidePageIndicatorControl;
